// Multi-property ("Airbnb") orders are superseded by commercial accounts
// (parent + locations). The backend still supports them; this only hides the UI.
export const MULTI_PROPERTY_ENABLED = false;
